export default "__VITE_ASSET__CeOvX6Mu__"